import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home')
const Layout = () => import('@/views/Layout')

const routes = [
  {
    path: '',
    redirect: '/home'
  },
  {
    path: '/home',
    meta: { title: '首页' },
    component: Home
  },
    {
    path: '/cjgsDetail/:id',
    meta: { title: '详情' },
    component: () => import('@/views/CjgsDetail')
  },
  {
    path: '/messageDetail/:id',
    meta: { title: '详情' },
    component: () => import('@/views/MessageDetail')
  },
  {
    path: '/detailInfo/:id',
    meta: { title: '详情' },
    component: () => import('@/views/DetailInfo')
  },
  {
    path: '/zx',
    component:Layout,
    meta: { title: '咨询' },
    children:[
      {
        path: 'gsdt/:category',
        meta: { title: '公司动态' },
        component: () => import('@/views/Message')
      },
      {
        path: 'hyzx/:category',
        meta: { title: '行业资讯' },
        component: () => import('@/views/Message')
      },
      {
        path: 'tzgg/:category',
        meta: { title: '通知公告' },
        component: () => import('@/views/Message')
      }
    ]
  },
  {
    path: '/xm',
    meta: { title: '项目' },
    component:Layout,
    children: [
      {
        path: 'ksrk',
        meta: { title: '快速入口',parentTitle:'快速入口' },
        component: () => import('@/views/Detail')
      },
      {
        path: 'zczr',
        component:Layout,
        meta: { title: '资产转让' },
        redirect: '/xm/zczr/1',
        children: [
          {
            path: '1',
            meta: { title: '房屋',parentTitle:'资产转让' },
            component: () => import('@/views/Detail')
          },
          {
            path: '2',
            meta: { title: '设备物资',parentTitle:'资产转让' },
            component: () => import('@/views/Detail')
          },
          // {
          //   path: '3',
          //   meta: { title: '物资',parentTitle:'资产转让' },
          //   component: () => import('@/views/Detail')
          // },
          {
            path: '3',
            meta: { title: '车辆',parentTitle:'资产转让' },
            component: () => import('@/views/Detail')
          },
          {
            path: '4',
            meta: { title: '其他',parentTitle:'资产转让' },
            component: () => import('@/views/Detail')
          }
        ]
      },
      {
        path: 'zczl',
        component:Layout,
        meta: { title: '资产租赁' },
        redirect: '/xm/zczl/5',
        children: [
          {
            path: '5',
            meta: { title: '房屋',parentTitle:'资产租赁' },
            component: () => import('@/views/Detail')
          },
          // {
          //   path: '7',
          //   meta: { title: '土地',parentTitle:'资产租赁' },
          //   component: () => import('@/views/Detail')
          // },
          {
            path: '6',
            meta: { title: '场地区域',parentTitle:'资产租赁' },
            component: () => import('@/views/Detail')
          },
          {
            path: '7',
            meta: { title: '设备',parentTitle:'资产租赁' },
            component: () => import('@/views/Detail')
          },
          {
            path: '8',
            meta: { title: '其他',parentTitle:'资产租赁' },
            component: () => import('@/views/Detail')
          }
        ]
      },
      {
        path: 'zhjy',
        component:Layout,
        meta: { title: '综合交易' },
        redirect: '/xm/zhjy/9',

        children: [
          {
            path: '9',
            meta: { title: '特许经营权',parentTitle:'综合交易' },
            component: () => import('@/views/Detail')
          },
          {
            path: '10',
            meta: { title: '债权',parentTitle:'综合交易' },
            component: () => import('@/views/Detail')
          },
          {
            path: '11',
            meta: { title: '数据信息',parentTitle:'综合交易' },
            component: () => import('@/views/Detail')
          },
          {
            path: '12',
            meta: { title: '专栏',parentTitle:'综合交易' },
            component: () => import('@/views/Detail')
          }
        ]
      },
      {
        path: 'nccq',
        component:Layout,
        meta: { title: '农村产权' },
        redirect: '/xm/nccq/13',

        children: [
          {
            path: '13',
            meta: { title: '房屋',parentTitle:'农村产权' },
            component: () => import('@/views/Detail')
          },
          {
            path: '14',
            meta: { title: '土地',parentTitle:'农村产权' },
            component: () => import('@/views/Detail')
          },
          {
            path: '15',
            meta: { title: '设备',parentTitle:'农村产权' },
            component: () => import('@/views/Detail')
          },
          {
            path: '16',
            meta: { title: '其他',parentTitle:'农村产权' },
            component: () => import('@/views/Detail')
          }
        ]
      },
      {
        path: 'ygzb',
        component:Layout,
        meta: { title: '阳光招标' },
        redirect: '/xm/ygzb/17',

        children: [
          {
            path: '17',
            meta: { title: '工程项目',parentTitle:'阳光招标' },
            component: () => import('@/views/Detail')
          },
          {
            path: '18',
            meta: { title: '采购项目',parentTitle:'阳光招标' },
            component: () => import('@/views/Detail')
          }
        ]
      },
      {
        path: 'cjgs',
        meta: { title: '成交公示',parentTitle:'成交公示' },
        component: () => import('@/views/Cjgs')
      },
      {
        path: 'zstj',
        meta: { title: '招商推介',parentTitle:'招商推介' },
        component: () => import('@/views/Detail')
      }
    ]
    // component:() => import('@/views/DetailInfo')
  },
  {
    path: '/jj',
    component:Layout,
    meta: { title: '竞价' },
    children:[
      {
        path: 'zcfg/:category',
        meta: { title: '政策法规' },
        component: () => import('@/views/Message')
      },
      {
        path: 'jylc/:category',
        meta: { title: '交易流程' },
        component: () => import('@/views/Message')
      },
      {
        path: 'jjxz/:category',
        meta: { title: '竞价须知' },
        component: () => import('@/views/Message')
      },
      {
        path: 'wjxz/:category',
        meta: { title: '文件下载' },
        component: () => import('@/views/Message')
      }
    ]
  },
  {
    path: '/hd',
    component:Layout,
    meta: { title: '互动' },
    children:[
      {
        path: 'qywh',
        meta: { title: '企业文化' },
        component: () => import('@/views/Qywh')
      },
      {
        path: 'lxwm',
        meta: { title: '联系我们' },
        component: () => import('@/views/Lxwm')
      },
      // {
      //   path: 'zxzx',
      //   meta: { title: '在线咨询' },
      //   component: () => import('@/views/Message')
      // }
    ]
  },
  {
    path: '/wzdt',
    meta: { title: '网站地图' },
    component: () => import('@/views/Wzdt')
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 始终滚动到顶部
    return { x: 0, y: 0 };
  }
})

export default router